import { render, staticRenderFns } from "./ModalProfileLogo.vue?vue&type=template&id=6006d078&scoped=true&"
import script from "./ModalProfileLogo.vue?vue&type=script&lang=js&"
export * from "./ModalProfileLogo.vue?vue&type=script&lang=js&"
import style0 from "./ModalProfileLogo.vue?vue&type=style&index=0&id=6006d078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6006d078",
  null
  
)

export default component.exports